import {
  createStandardAction,
  createReducer,
  StateType
} from "typesafe-actions";
import _ from "lodash";
import { PolicyDeploymentScope } from "generated/graphql";
import { DesktopDevicePolicyScope } from "routes/Manage/Inventory/Settings-Desktop/ProvisionedDesktopDeviceSettingsRouter";
import { resetDesktopDeviceSettingsInheritanceAndNav } from "./desktopDeviceSettings";

type DesktopDeviceSettingInheritancePayload = {
  key: string;
  value: string;
  scope: DesktopDevicePolicyScope;
  id: string;
};
export type InheritanceDetails = {
  scope: DesktopDevicePolicyScope | PolicyDeploymentScope;
  value: string;
  id: string;
};
export type DesktopDeviceSettingInheritance = {
  [key: string]: InheritanceDetails;
};

export const desktopDeviceSettingInheritance = createStandardAction(
  "DESKTOP_DEVICE_SETTING_INHERITANCE"
)<DesktopDeviceSettingInheritancePayload>();
export const resetDesktopDeviceSettingInheritance = createStandardAction(
  "RESET_DESKTOP_DEVICE_SETTING_INHERITANCE"
)();

export const defaultDesktopDeviceSettingInheritanceState: DesktopDeviceSettingInheritance = {};

export const DesktopDeviceSettingInheritanceReducer = createReducer(
  defaultDesktopDeviceSettingInheritanceState
)
  .handleAction(desktopDeviceSettingInheritance, (state, action) => {
    const { value, scope, key, id } = action.payload;

    // only update state if needed
    if (
      scope !== state[key]?.scope ||
      id !== state[key]?.id ||
      value !== state[key]?.value
    ) {
      if (scope) {
        // add change to state
        if (id && value) {
          return {
            ...state,
            [key]: {
              scope,
              value,
              id
            }
          };
        }
      } else {
        // delete change from state (and delete empty objects along path if any)
        const newState = _.cloneDeep(state);
        _.unset(newState, [value]);
        return newState;
      }
    }

    return state;
  })
  .handleAction(
    resetDesktopDeviceSettingInheritance,
    (state, action) => defaultDesktopDeviceSettingInheritanceState
  )
  .handleAction(
    resetDesktopDeviceSettingsInheritanceAndNav,
    (state, action) => defaultDesktopDeviceSettingInheritanceState
  );

export type DesktopDeviceSettingInheritanceState = StateType<
  typeof DesktopDeviceSettingInheritanceReducer
>;
